import React, { Fragment, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { appContext } from "../../../Utils/context";
import util from "../../../Utils/util";
import PerfectScrollbar from "react-perfect-scrollbar";
import SetupUser from "./SetupUser";
import {
  DropdownToggle,Dropdown,
  DropdownMenu,
  Button, ListGroup, ListGroupItem,
  Card, CardHeader, Modal, ModalBody,
} from "reactstrap";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'react-toastify/dist/ReactToastify.css';
import city3 from "../../../assets/utils/images/dropdown-header/city3.jpg";
import avatar1 from "../../../assets/utils/images/user.png";


export default function UserBox() {
  const history = useHistory()
  const { user, userWizard, toggleUserWizard, wizardBackdrop } = useContext(appContext)
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const logout = () => {
    util.logout()
  }



  return (
    <Fragment>
      <div className="header-btn-lg pe-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle color="link" className="p-0">
                  <img width={42} className="rounded-circle" src={avatar1} alt="" />
                  <FontAwesomeIcon
                    className="ms-2 opacity-8"
                    icon={faAngleDown}
                  />
                </DropdownToggle>
                <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                  <div className="dropdown-menu-header">
                    <div className="dropdown-menu-header-inner bg-info">
                      <div className="menu-header-image opacity-2"
                        style={{
                          backgroundImage: "url(" + city3 + ")",
                        }} />
                      <div className="menu-header-content text-start">
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <div className="widget-content-left me-3">
                              <img width={42} className="rounded-circle" src={avatar1} alt="" />
                            </div>
                            <div className="widget-content-left">
                              <div className="widget-heading">
                                {user?.first_name} {user?.last_name}
                              </div>
                              <div className="widget-subheading opacity-8">
                                {user?.email}
                              </div>
                            </div>
                            <div className="widget-content-right me-2">
                              <Button className="btn-pill btn-shadow btn-shine" color="focus" onClick={logout}>
                                Logout
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="scroll-area-xs"
                    style={{
                      height: "170px",
                    }}>

                    <PerfectScrollbar>
                      <ListGroup >
                        {/* {user?.is_staff && (
                          <ListGroupItem>
                            <div className="widget-content p-0">
                              <div className="widget-content-wrapper">
                                <div className="widget-content-right">
                                  <div className="fw-bold text-primary">
                                    <Button color="success" onClick={toggleUserWizard}>Setup User</Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ListGroupItem>
                        )} */}

                        <ListGroupItem>
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  Phone
                                </div>
                              </div>
                              <div className="widget-content-right">
                                <div className="fw-bold text-primary">
                                  {user?.phone || "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem>
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  Second Email
                                </div>
                              </div>
                              <div className="widget-content-right">
                                <div className="fw-bold text-primary">
                                  {user?.email2 || "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem>
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  Address
                                </div>
                              </div>
                              <div className="widget-content-right">
                                <div className="fw-bold text-primary">
                                  {user?.state} {user?.city} {user?.zip} {user?.address}
                                </div>
                              </div>
                            </div>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem>
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <Button className="mt-1" block outline color="primary" onClick={() => {toggle(); history.push('/profile')}}>More Details</Button>
                            </div>
                          </div>
                        </ListGroupItem>
                      </ListGroup>

                    </PerfectScrollbar>
                  </div>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="widget-content-left  ms-3 header-user-info">
              <div className="widget-heading">{user?.first_name || "Name"} {user?.last_name}</div>
              <div className="widget-subheading">{user?.email || "Email"}</div>
            </div>

          </div>
        </div>
      </div>

      <Modal isOpen={userWizard} toggle={toggleUserWizard} backdrop={wizardBackdrop || true} style={{ minWidth: "55%" }}>
        <Card>
          <CardHeader className="card-header-tab z-index-6">
            <div className="card-header-title font-size-lg text-capitalize fw-normal">
              <i className="header-icon lnr-user icon-gradient bg-happy-green"> {" "} </i>
              <span className="mt-1 ms-1"> Setup User</span>
            </div>
          </CardHeader>
        </Card>
        <ModalBody className="pt-0">
          <SetupUser />
        </ModalBody>

      </Modal>
    </Fragment>
  );

}


